module.exports = __webpack_public_path__ + "img/receive-money-flat_hand.8b691592.svg";